query GetColor($colorId: String!) {
    Color(id: $colorId) {
        id
        hexColor
    }
}
